import { apiUrl } from '@/config';


const http = (opt) => {
  const { axios } = window.__kaer_adapt__
  const { url, method, params, config = {} } = opt;
  const options = method.toLocaleLowerCase() === 'get' ? { params } : params;
  return axios[method.toLocaleLowerCase()](apiUrl+url, options, config);
};

export default http;
